import PasswordResetErrorContainer from "../containers/PasswordResetErrorContainer";

const PasswordResetErrorPage = () => {
  return <PasswordResetErrorContainer />;
};

export default PasswordResetErrorPage;
